import { clsx } from 'clsx'
import { type FC, type PropsWithChildren } from 'react'

type TableDivisionProps = PropsWithChildren<{
  className?: string
}>

export const RxLpComHowBonusIsCalculatedTableDivision: FC<
  TableDivisionProps
> = ({ children, className }) => {
  return <td className={clsx('px-4 py-3', className)}>{children}</td>
}
